/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CLICKABLE_HEIGHT = 56;

const ClickableIcon = (props) => {
  const styleClass = classnames('cmp-clickable-icon', {
    'align-right': props.align === 'right',
    'align-left': props.align === 'left',
  });
  const { clickableHeight = CLICKABLE_HEIGHT } = props;
  const styles = {};
  if (props.iconSize) {
    styles.marginTop = (props.iconSize - clickableHeight) / 2;
    styles.marginBottom = (props.iconSize - clickableHeight) / 2;
  }

  return (
    <div className={styleClass} style={styles} onClick={props.onClick}>
      {props.children}
    </div>
  );
};
ClickableIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.element,
  align: PropTypes.oneOf(['left', 'right']),
  iconSize: PropTypes.number,
  clickableHeight: PropTypes.number,
};

export default ClickableIcon;
